import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

import Img1 from "./Images/grocessary.jpg";
import Img2 from "./Images/grocessary1.jpg";
import Img3 from "./Images/grocessary2.jpg";
import Img4 from "./Images/grocessary3.jpg";

const EssentialsSection = () => {
  const essentials = [
    { title: "Snacks & Packaged", img: Img1, desc: "Sourced from leading brands in business-friendly quantities." },
    { title: "Flours & Grains", img: Img3, desc: "Daily-use flours—atta, maida, rice—available in bulk for every kitchen." },
    { title: "Edible Oil & Ghee", img: Img2, desc: "Sunflower, groundnut oil, and ghee supplied for commercial kitchens." },
    { title: "Pulses & Lentils", img: Img4, desc: "Toor dal, moong, and chana—sorted and packed for bulk cooking." },
  ];

  return (
    <section className="bg-gray-100 py-24 px-6 md:px-16">
      <div className="max-w-7xl mx-auto">
        
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8">
          
          <div className="md:w-2/3">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-[2px] bg-yellow-500"></span>
              <h4 className="text-yellow-500 font-semibold tracking-[0.3em] uppercase text-xs">
                Daily Essentials
              </h4>
            </div>

            <h2 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight">
              Smart. Swift. <br />
              <span className="text-gray-300">Everything you need.</span>
            </h2>
          </div>

          <div className="md:w-1/3">
            <p className="text-gray-600 text-lg leading-relaxed border-l-2 border-yellow-500 pl-6">
              Tailored for retailers, hotels, and warehouses. We simplify your supply chain with transparent pricing.
            </p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {essentials.map((item, index) => (
            <div 
              key={index} 
              className="group relative bg-white border border-gray-200 overflow-hidden rounded-xl hover:shadow-xl transition-all duration-500"
            >
              {/* Image */}
              <div className="h-64 relative overflow-hidden rounded-t-xl">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition duration-700"
                />

                {/* Optional subtle hover overlay */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition"></div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-yellow-500 transition uppercase">
                  {item.title}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  {item.desc}
                </p>
                
                <Link
                  to="/ServiceIndex"
                  className="inline-flex items-center gap-2 text-yellow-500 text-xs font-semibold uppercase tracking-wider"
                >
                  Explore <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>

              {/* Number */}
              <span className="absolute top-4 right-4 text-gray-200 font-black text-4xl italic">
                0{index + 1}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 flex justify-center">
          <Link
            to="/ServiceIndex"
            className="bg-yellow-500 text-black font-bold px-10 py-4 rounded-full hover:bg-yellow-400 transition flex items-center gap-3 shadow-md"
          >
            Explore Full Inventory <ArrowUpRight className="w-5 h-5" />
          </Link>
        </div>

      </div>
    </section>
  );
};

export default EssentialsSection;